import React from "react";

export const Advisors = () => {
  return (
    <div id="team2">
      <section className="lg:pb-[100px] pb-[50px]">
        <div className="container lg:px-10 px-4">
          <div className="lg:mb-[80px] max-w-[1000px] mx-auto lg:px-10 px-4">
            <h3 className="text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[35px] sm:text-[25px] text-[22px] mb-8">
              ADVISORS
            </h3>
            <p className="text-center lg:text-[18px] sm:text-[15px] text-[14px] text-center">
              The Successfull and connected individuals who are excited about
              the Global Mentor Exchange and use their knowledge and resources
              to support project success
            </p>
          </div>
          <div className="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-8">
            <div className="flex lg:flex-row flex-col lg:text-left text-center gap-3 mt-8 items-center">
              <img
                src="/assets/ad1.png"
                className="rounded-full lg:h-[180px] h-[100px] lg:w-[180px] w-[100px] object-cover border border-[5px] border-[#751efe]"
              />
              <div>
                <h3 className="text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] font-bold mb-3">
                  Andrey Logunov
                </h3>
                <p className="mb-3">
                  CTO attarius.com | Founder at AdaptiveStone and successful
                  Tech Start-up Entrepreneur
                </p>
                <div className="flex lg:justify-start justify-center gap-5">
                  <a className href="javascript:void(0);">
                    <i className="fa-brands fa-facebook-f text-gray-500" />
                  </a>
                  <a className href="javascript:void(0);">
                    <i className="fa-brands fa-twitter text-gray-500" />
                  </a>
                  <a className href="javascript:void(0);">
                    <i className="fa-brands fa-linkedin text-gray-500" />
                  </a>
                </div>
              </div>
            </div>
            <div className="flex lg:flex-row flex-col lg:text-left text-center gap-3 mt-8 items-center">
              <img
                src="/assets/ad2.png"
                className="rounded-full lg:h-[180px] h-[100px] lg:w-[180px] w-[100px] object-cover border border-[5px] border-[#751efe]"
              />
              <div>
                <h3 className="text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] font-bold mb-3">
                  Kumardev Chaterjee
                </h3>
                <p className="mb-3">
                  Regional Manager || Internet Computer Protocol || ICP at
                  DFINITY
                </p>
                <div className="flex lg:justify-start justify-center gap-5">
                  <a className href="javascript:void(0);">
                    <i className="fa-brands fa-facebook-f text-gray-500" />
                  </a>
                  <a className href="javascript:void(0);">
                    <i className="fa-brands fa-twitter text-gray-500" />
                  </a>
                  <a className href="javascript:void(0);">
                    <i className="fa-brands fa-linkedin text-gray-500" />
                  </a>
                </div>
              </div>
            </div>

            <div className="flex lg:flex-row flex-col lg:text-left text-center gap-3 mt-8 items-center">
              <img
                src="/assets/ad3.png"
                className="rounded-full lg:h-[180px] h-[100px] lg:w-[180px] w-[100px] object-cover border border-[5px] border-[#751efe]"
              />
              <div>
                <h3 className="text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] font-bold mb-3">
                  Andrey Logunov
                </h3>
                <p className="mb-3">
                  Renound Metaverse Consultant for the Dubal Government and
                  INTERPOL
                </p>
                <div className="flex lg:justify-start justify-center gap-5">
                  <a className href="javascript:void(0);javascript:void(0);">
                    <i className="fa-brands fa-facebook-f text-gray-500" />
                  </a>
                  <a className href="javascript:void(0);javascript:void(0);">
                    <i className="fa-brands fa-twitter text-gray-500" />
                  </a>
                  <a className href="javascript:void(0);javascript:void(0);">
                    <i className="fa-brands fa-linkedin text-gray-500" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
